import React from "react";
import ComposeView from "../../index";

interface ComposePageProps {
  page?: boolean;
  onFinish?: () => void;
  onClose: () => void;
}

const ComposePage: React.FC<ComposePageProps> = ({
  onFinish,
  onClose,
}) => {
  return <ComposeView width={"100%"} onFinish={onFinish} onClose={onClose} />;
};

export default ComposePage;
